import { StrictMode } from "react"
import { createRoot } from "react-dom/client"
import "./index.css"
import "@/branding" // laedt Theme-CSS des aktiven Brands (VITE_BRAND) + setzt document.title
import App from "./App"

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
)
